import React from 'react'
import ClientLayout from '../layout/ClientLayout'

function ClientListPage() {
  return (
    <ClientLayout>
      <div>ClientListPage</div>
    </ClientLayout>
  )
}

export default ClientListPage